import { supabase } from '../../shared/supabase/supabaseClient';
import { patchWebCatalogProductInCache } from './catalogRamSnapshotCache';
import { useCatalogOverlayStore } from '../store/useCatalogOverlayStore';
import { shouldClearPhantomBarcode, trimProductSku } from './productSkuServerPatchPolicy';
export {
  shouldApplyRemoteProductDespiteLocalNewer,
  shouldClearPhantomBarcode,
} from './productSkuServerPatchPolicy';

export async function patchLocalProductSkuFromServer(productId: string): Promise<string | null> {
  const trimmedId = productId.trim();
  if (!trimmedId) return null;

  try {
    const { data, error } = await supabase
      .from('products')
      .select('sku, barcode, updated_at')
      .eq('id', trimmedId)
      .maybeSingle();

    if (error || !data) return null;

    const sku = trimProductSku(data.sku);
    const serverBarcode = trimProductSku(data.barcode);

    // ADR-017 Fase 4: SQLite local eliminado. clearBarcode dependía de un read
    // local que siempre retornaba undefined (stub), por lo que nunca se ejecutaba.
    // El patch del SKU va directo al cache web RAM.

    if (!sku) return null;

    const updatedAt =
      data.updated_at != null && String(data.updated_at).trim() !== ''
        ? String(data.updated_at)
        : new Date().toISOString();

    const webPatch: Partial<{ sku: string; updated_at: string }> = {};
    webPatch.sku = sku;
    webPatch.updated_at = updatedAt;
    patchWebCatalogProductInCache(trimmedId, webPatch);

    const selected = useCatalogOverlayStore.getState().selectedProduct;
    if (selected?.id === trimmedId) {
      const nextSku = trimProductSku(selected.sku) || sku || selected.sku;
      const clearSelectedBarcode = shouldClearPhantomBarcode({
        serverBarcode,
        localBarcode: selected.barcode,
        localSku: nextSku,
      });
      useCatalogOverlayStore.getState().setSelectedProduct({
        ...selected,
        ...(sku && !trimProductSku(selected.sku) ? { sku, updatedAt } : {}),
        ...(clearSelectedBarcode ? { barcode: null } : {}),
      });
    }

    return sku || null;
  } catch (error) {
    console.warn('[catalog] patchLocalProductSkuFromServer failed', error);
    return null;
  }
}

